<div class="stepper">
  @for (item of dataList; track item.rankId || $index) {
    <div class="step" [ngClass]="getStepClass(item)">
      <img
        [src]="getImageInfo(item)"
        [alt]="item.name"
        class="logo std-mg-bottom-2m"
      />
      <div class="circle">
        @if (isCompleted(item)) {
          <nx-icon name="check" size="s" class="check_icon"></nx-icon>
        }
      </div>
      <div class="label break_word">{{ item.name }}</div>
    </div>
  }
</div>
